<div id="manager-state-of-car-informations" uk-modal>
    <div class="uk-modal-dialog wrap wrap-width">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div *ngIf="loading === false" class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase uk-margin-small-bottom">
                    État gestionnaire
                </h2>
                <a href="#" [routerLink]="['/ressource/vehicle/informations/' + managerState.vehicle.id ]" style="width: max-content;"
                class="main-title regular color-cold-grey links uk-display-block pointer uk-modal-close uk-margin-bottom">
                    {{ managerState.vehicle.name }}
                    <div class="uk-display-inline-block" *ngIf="relatedStates.length === 0">
                        <span *ngIf="managerState.part === 1">(Avant)</span>
                        <span *ngIf="managerState.part === 2">(Arrière)</span>
                        <span *ngIf="managerState.part === 3">(Aile gauche)</span>
                        <span *ngIf="managerState.part === 4">(Aile droite)</span>
                    </div>
                </a>
                <div uk-grid class="uk-grid-small">
                    <a href="#" class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block pointer uk-modal-close"
                    [routerLink]="['/user/informations/' + managerState.societyVopUser.AccountId ]"
                    *ngIf="managerState.societyVopUser.FirstName.length !== 0 && managerState.societyVopUser.LastName.length !== 0">
                        <img src="../../../../assets/icons/User.svg" width="40px" height="40px" class="vertical-align-middle">
                        <span class="vertical-align-middle color-dark-turquoise bold uk-text-uppercase">
                            {{ managerState.societyVopUser.FirstName }} {{ managerState.societyVopUser.LastName }}
                        </span>
                    </a>
                    <div class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block"
                    *ngIf="managerState.ISOCreated.length !== 0">
                        <img src="../../../../assets/icons/Booking.svg" width="40px" height="40px">
                        <span class="vertical-align-middle color-cold-grey regular uk-text-uppercase">
                            Déclaré le <span humanDateFormat="{{ managerState.ISOCreated }}" shortened="true" class="bold"></span> à {{managerState.ISOCreated | date:'HH:mm'}}
                        </span>
                    </div>
                </div>
                <div style="min-height: 500px; margin-top: 0px;" uk-grid>
                    <div *ngIf="relatedStates.length === 0" class="uk-width-8-12@s">
                        <div class="img-wrap" uk-lightbox>
                            <div *ngIf="loadingPhoto === true" class="uk-position-center" uk-spinner></div>
                            <a *ngIf="loadingPhoto === false" class="uk-button uk-button-default" [href]="managerState.imgs[0]">
                                <img [src]="managerState.imgs[0]" onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                            </a>
                            <button class="uk-position-absolute button large edit-button" (click)="modifyPhoto(managerState)">
                                <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                            </button>
                        </div>
                    </div>
                    <div *ngIf="relatedStates.length > 0" class="uk-width-8-12@s uk-grid-small@s" uk-grid>
                        <div *ngFor="let state of managerStates; let i = index" class="uk-width-6-12@m pictureMobile">
                            <div class="img-wrap" uk-lightbox>
                                <div *ngIf="loadingPhoto === true" class="uk-position-center" uk-spinner></div>
                                <a *ngIf="loadingPhoto === false" class="uk-button uk-button-default" [href]="state.imgs[0]">
                                    <span *ngIf="state.part === 1" class="tag bold">Avant</span>
                                    <span *ngIf="state.part === 2" class="tag bold">Arrière</span>
                                    <span *ngIf="state.part === 3" class="tag bold">Gauche</span>
                                    <span *ngIf="state.part === 4" class="tag bold">Droite</span>
                                    <img [src]="state.imgs[0]" onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                                </a>
                                <button class="uk-position-absolute button large edit-button" (click)="modifyPhoto(state)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-4-12@s">
                        <div class="uk-form-stacked">
                            <div class="uk-margin">
                                <label class="label">Titre</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <input [(ngModel)]="managerState.title" class="input alt color-cold-grey bold uk-width-1-1" type="text">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="label">Commentaire</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <input [(ngModel)]="managerState.comment" class="input alt color-cold-grey bold uk-width-1-1" type="text">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="label">Statut</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <select [(ngModel)]="managerState.state" class="combo-list alt color-cold-grey bold uk-width-1-1">
                                        <option value="0">Publié</option>
                                        <option value="1">Archivé</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" type="button" (click)="updateState()">
                    Sauvegarder
                </button>
            </p>
        </div>
    </div>
</div>